import React from 'react';
import PropTypes from 'prop-types';

const MotifTableCellRenderer = React.memo(
  ({ value }) => <span className="motif-table-end-component-renderer" data-motif-table-cell-renderer>{value}</span>,
  (prevProps, nextProps) => prevProps.value === nextProps.value
);

MotifTableCellRenderer.defaultProps = {
  value: null
};

MotifTableCellRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType])
};

export { MotifTableCellRenderer };
